import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

function Searchbar(props) {
  const { setting } = props
  const { id, size, extraClass, title, action, method } = setting
  const [focus, setFocus] = useState(false)
  const [search, setSearch] = useState('')
  const textAreaRef = useRef(null)

  const resizeTextArea = () => {
    if (textAreaRef.current && textAreaRef.current.scrollHeight < 250) {
      textAreaRef.current.style.height = 'auto'
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`
    }
  }

  useEffect(() => {
    resizeTextArea()
  }, [search])

  return (
    <InputGroup
      id={id}
      className={`align-items-center h-100 px-3 py-1 searchBar${
        extraClass || ''
      }`}
      size={size}
    >
      <FormControl
        ref={textAreaRef}
        placeholder={title}
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        as="textarea"
        style={{
          resize: 'none',
          overflowY: 'hidden',
          border: 'none',
        }}
        onKeyDown={(event) => {
          // shift+enter  要換行
          if (event.key === 'Enter' && event.shiftKey) return
          if (
            event.key === 'Enter' &&
            !event.nativeEvent.isComposing &&
            focus
          ) {
            event.preventDefault()
            setSearch('')
            method(search)
          }
        }}
      />
      <Button
        variant="outline-dai"
        id="button-addon2"
        className="search-submit-btn position-absolute"
        title="搜 尋"
        onClick={() => {
          setSearch('')
          method(search)
        }}
      >
        {action || <FontAwesomeIcon icon={faSearch} />}
      </Button>
    </InputGroup>
  )
}

Searchbar.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default Searchbar
